import type { Plurals, Strings } from '../index';

export const strings: Strings = {
  'menu.home': 'Acasă',
  'menu.notes': 'Notițe',
  'menu.reminders': 'Mementouri',
  'menu.passwords': 'Parole',
  'menu.cards': 'Carduri',
  'menu.photoIds': 'Acte de identitate',
  'menu.collections': 'Colecții',
  'menu.conflicts': 'Conflicte ({count})',
  'menu.settings': 'Setări',
  'menu.lock': 'Blochează portofelul',
  'menu.language': 'Limbă',

  'type.note': 'Notiță',
  'type.note.plural': 'Notițe',
  'type.password': 'Parolă',
  'type.password.plural': 'Parole',
  'type.card': 'Card',
  'type.card.plural': 'Carduri',
  'type.photoId': 'Act de identitate',
  'type.photoId.plural': 'Acte de identitate',

  'section.upcoming': 'Mementouri viitoare',
  'section.pinned': 'Fixate',
  'section.recent': 'Recente',
  'section.searchResults': 'Rezultatele căutării',
  'section.conflicts': 'Conflicte',

  'action.addNew': '+ Adaugă',
  'action.back': 'Înapoi',
  'search.placeholder': 'Caută sau adaugă ceva nou',

  'gate.title': 'Tot ce contează',
  'gate.copy': 'Portofelul tău este criptat pe acest dispozitiv înainte de orice sincronizare.',
  'gate.create': 'Creează un portofel nou',
  'gate.open': 'Deschide portofelul meu existent',
  'gate.recover': 'Recuperează accesul la portofel',

  'empty.addFirst': 'Adaugă primul tău element.',
  'empty.nothingHere': 'Încă nimic aici.',
  'empty.noResults': 'Niciun element salvat nu corespunde căutării.',

  'action.cancel': 'Anulează',
  'action.save': 'Salvează',
  'action.saving': 'Se salvează…',
  'action.close': 'Închide',
  'action.edit': 'Editează',
  'action.delete': 'Șterge',
  'action.remove': 'Elimină',
  'action.change': 'Schimbă',
  'action.clear': 'Golește',
  'action.add': 'Adaugă',
  'action.show': 'Arată',
  'action.hide': 'Ascunde',
  'action.more': 'Mai multe',

  'field.title': 'Titlu',
  'field.body': 'Conținut',
  'field.username': 'Nume de utilizator',
  'field.password': 'Parolă',
  'field.website': 'Site web',
  'field.notes': 'Notițe',
  'field.cardNumber': 'Numărul cardului',
  'field.documentNumber': 'Numărul documentului',
  'field.expiry': 'Expiră la',
  'field.securityCode': 'Cod de securitate',
  'field.cvv': 'CVV / CVC',
  'field.pin': 'PIN',
  'field.documentType': 'Tipul documentului',
  'field.reminder': 'Memento',
  'field.collections': 'Colecții',
  'field.idPhotos': 'Fotografiile actului',
  'field.attachments': 'Atașamente',

  'editor.newItem': 'Nou: {type}',
  'editor.editItem': 'Editează: {type}',
  'editor.titlePlaceholder': 'Titlu ({type})',
  'editor.selectDocumentType': 'Alege tipul documentului',
  'editor.noneSelected': 'Nimic selectat',
  'editor.optional': 'Opțional',
  'editor.optionalFields': 'Câmpuri opționale',
  'editor.reminderDate': 'Data mementoului',
  'editor.optionalTime': 'Ora (opțional)',
  'editor.shortcutHint': 'Ctrl+Enter salvează. Esc anulează.',
  'editor.addTitle': 'Adaugă un titlu.',
  'editor.saveFailed': 'Acest element nu a putut fi salvat.',
  'editor.photoFailed': 'Această fotografie nu a putut fi pregătită.',
  'editor.attachmentFailed': 'Acest atașament nu a putut fi pregătit.',
  'editor.photoNote': 'Fotografiile de până la {mb} MB sunt criptate și salvate pe acest dispozitiv, apoi sincronizate automat dacă sincronizarea este activă.',
  'editor.attachmentNote': 'Fișierele sunt criptate exact așa cum au fost alese și salvate pe acest dispozitiv. Safe Wallet blochează tipurile obișnuite de fișiere executabile, scripturi, conținut web activ și fișiere cu macrocomenzi, dar nu le scanează de programe dăunătoare.',
  'editor.attachmentButton': 'Atașament (max. {mb} MB)',
  'editor.addingAttachment': 'Se adaugă atașamentul…',
  'editor.preparing': 'Se pregătește…',
  'editor.takePhoto': 'Fă o fotografie',
  'editor.choosePhoto': 'Alege o fotografie',
  'editor.front': 'Față',
  'editor.back': 'Verso',
  'editor.tapAddFront': 'Atinge pentru a adăuga fața',
  'editor.tapAddBack': 'Atinge pentru a adăuga versoul',
  'editor.photoNotOnDevice': 'Fotografia criptată nu este salvată pe acest dispozitiv.',
  'editor.pinItem': 'Fixează',
  'editor.pinned': 'Fixat',
  'editor.deleteItem': 'Șterge elementul',

  'viewer.noBody': 'Fără text.',
  'viewer.notSet': 'Necompletat',
  'viewer.escCloses': 'Esc închide această vizualizare.',

  'attach.title': 'Atașament',
  'attach.notOnDevice': 'Atașamentul criptat nu este încă salvat pe acest dispozitiv.',
  'attach.photoNotOnDevice': 'Fotografia criptată nu este încă salvată pe acest dispozitiv.',
  'attach.openingPhoto': 'Se deschide fotografia criptată…',
  'attach.opening': 'Se deschide…',
  'attach.notStored': 'Nesalvat pe acest dispozitiv',
  'attach.couldNotOpen': 'Acest atașament nu a putut fi deschis.',
  'attach.previewUnavailable': 'Previzualizarea nu este disponibilă pentru acest tip de fișier. Descarcă-l și deschide-l cu o aplicație în care ai încredere.',
  'attach.previewLimited': 'Previzualizare limitată la primul MB.',
  'attach.openPdf': 'Deschide PDF-ul',
  'attach.download': 'Descarcă',

  'expiry.label': 'Expiră la (LL/AA)',
  'expiry.month': 'Luna expirării',
  'expiry.chooseMonthYear': 'Alege luna și anul',
  'expiry.chooseDate': 'Alege data expirării',
  'expiry.previousYear': 'Anul precedent',
  'expiry.nextYear': 'Anul următor',

  'collections.createFirst': 'Creează mai întâi colecții din meniul principal.',
  'chooser.addNew': 'Adaugă',

  'settings.title': 'Setări',
  'settings.account': 'Cont',
  'settings.security': 'Securitate',
  'settings.recovery': 'Recuperare',
  'settings.thisDevice': 'Acest dispozitiv',
  'settings.appearance': 'Aspect',
  'settings.searchPrivacy': 'Confidențialitatea căutării',
  'settings.dangerZone': 'Zonă sensibilă',
  'settings.notSignedIn': 'Neconectat',
  'settings.pinOnly': 'Doar PIN',
  'settings.pinAndFingerprint': 'PIN + amprentă',
  'settings.changePinRow': 'Schimbă PIN-ul aplicației pe acest dispozitiv. Este necesar PIN-ul actual.',
  'settings.lockNow': 'Blochează acum',
  'settings.chooseAnotherWallet': 'Alege alt portofel',
  'settings.useAnotherAccount': 'Folosește alt cont',
  'settings.categoryLabels': 'Etichetele categoriilor',
  'settings.rowSpacing': 'Spațierea rândurilor',
  'settings.textSize': 'Mărimea textului',
  'settings.autoLock': 'Blocare automată',
  'settings.optionName': 'Nume',
  'settings.optionIcon': 'Pictogramă',
  'settings.optionBoth': 'Ambele',
  'settings.optionLarge': 'Mare',
  'settings.optionMedium': 'Mediu',
  'settings.optionCompact': 'Compact',
  'settings.optionSmall': 'Mic',
  'settings.searchPrivacyNote': 'Indexul de căutare decriptat există doar pe acest dispozitiv deblocat și este șters când portofelul se blochează. Parolele, PIN-urile, numerele de card și de cont, codurile de securitate, numerele de document, codurile de recuperare și alte secrete similare nu sunt niciodată indexate.',
  'settings.exampleProjection': 'Exemplu pentru primul element',
  'settings.noItemsYet': 'Încă niciun element.',
  'settings.removeWalletNote': 'Eliminarea acestui portofel din acest browser nu șterge copia de siguranță criptată din cont.',
  'settings.removeWallet': 'Elimină acest portofel local',

  'pin.changeTitle': 'Schimbă PIN-ul aplicației',
  'pin.change': 'Schimbă PIN-ul',
  'pin.changing': 'Se schimbă…',
  'pin.current': 'PIN-ul actual',
  'pin.new': 'PIN nou',
  'pin.repeat': 'Repetă noul PIN',
  'pin.accountPassword': 'Parola contului',
  'pin.accountPasswordHint': 'Necesară pentru a actualiza conectarea pe celelalte dispozitive.',
  'pin.noteSynced': 'Elementele salvate nu trebuie criptate din nou. Deoarece acest portofel se sincronizează, parola contului este necesară pentru ca noul PIN să funcționeze și la conectarea pe un dispozitiv nou.',
  'pin.noteLocal': 'PIN-ul actual deblochează acest portofel pe acest dispozitiv. Elementele salvate nu trebuie criptate din nou.',
  'pin.errCurrent': 'Introdu PIN-ul actual al aplicației, de 6 până la 12 cifre.',
  'pin.errNew': 'Folosește un PIN nou de 6 până la 12 cifre.',
  'pin.errMismatch': 'Cele două PIN-uri noi nu coincid.',
  'pin.errSame': 'Alege un PIN nou, diferit de cel actual.',
  'pin.errPassword': 'Introdu parola contului tău.',
  'pin.errFailed': 'PIN-ul aplicației nu a putut fi schimbat.',

  'fingerprint.title': 'Deblocare cu amprenta',
  'fingerprint.settingUp': 'Se configurează…',
  'fingerprint.unavailable': 'Acest dispozitiv nu poate face asta.',
  'fingerprint.errOn': 'Această opțiune nu a putut fi activată.',
  'fingerprint.errOff': 'Această opțiune nu a putut fi dezactivată.',

  'sync.off': 'Oprită — doar pe acest dispozitiv',
  'sync.notConfigured': 'Oprită — sincronizarea nu este configurată',
  'sync.connecting': 'Se conectează…',
  'sync.uploading': 'Pornită — se sincronizează copia criptată…',
  'sync.waiting': 'Pornită — modificările criptate așteaptă să fie încărcate',
  'sync.connected': 'Pornită — copie criptată conectată',
  'sync.offline': 'Offline — copia criptată este în pauză',

  'account.signedIn': 'Conectat',
  'account.signedInAs': 'Conectat ca',
  'account.anotherAccount': 'Alt cont',
  'account.currentAccount': 'Contul curent',
  'account.wallet': 'Portofel',
  'account.sync': 'Sincronizare',
  'account.device': 'Dispozitiv',
  'account.signOut': 'Deconectează-te',
  'account.signOutOf': 'Deconectează-te de la {account}',
  'account.email': 'E-mail',
  'account.pinLabel': 'PIN-ul Safe Wallet',
  'account.pinHint': 'PIN-ul tău pentru acest portofel. Dacă acest cont are deja un portofel, folosește PIN-ul acelui portofel.',
  'account.pinPlaceholder': '6–12 cifre',
  'account.signInTab': 'Conectare',
  'account.createTab': 'Creează cont',
  'account.forgotPassword': 'Ai uitat parola contului?',
  'account.signInSync': 'Conectează-te și sincronizează',
  'account.createSync': 'Creează cont și sincronizează',
  'account.signInSyncTitle': 'Conectare și sincronizare',
  'account.differentSession': 'În acest browser există un cont conectat, dar acest portofel local nu este legat de acel cont. Deschide „Conectare și sincronizare” mai jos pentru a lega contul căruia îi aparține acest portofel, sau deconectează-te mai întâi pentru alt cont.',
  'account.notConfigured': 'Sincronizarea nu este configurată pentru această instalare.',
  'account.confirmEmail': 'Confirmă contul din e-mail, apoi revino și conectează-te. Acest portofel local nu este încă legat.',
  'account.errPin': 'Introdu PIN-ul Safe Wallet de 6 până la 12 cifre pentru acest portofel.',
  'account.errSession': 'Sesiunea contului nu a putut fi stabilită.',
  'account.connected': 'Portofel conectat. Sincronizarea începe.',
  'account.connectedNoSync': 'Cont conectat. Sincronizarea nu este disponibilă în acest mediu.',
  'account.errConnect': 'Acest cont nu a putut fi conectat.',
  'account.resetSent': 'Verifică-ți e-mailul pentru linkul de resetare a parolei.',
  'account.errReset': 'E-mailul de resetare nu a putut fi trimis.',
  'account.signedOut': 'Deconectat de la cont. Portofelul criptat rămâne disponibil pe acest dispozitiv.',

  'pairing.advanced': 'Avansat: aprobă alt dispozitiv',
  'pairing.advancedNote': 'Folosește această opțiune doar când conectarea obișnuită cu parolă și PIN nu este disponibilă. Compară amprenta pe ambele dispozitive înainte de a aproba.',
  'pairing.none': 'Niciun dispozitiv în așteptare.',
  'pairing.invalidKey': 'Cheie de asociere nevalidă',
  'pairing.calculating': 'Se calculează amprenta…',
  'pairing.review': 'Verifică',
  'pairing.reviewTitle': 'Verifică dispozitivul nou',
  'pairing.fingerprint': 'Amprentă de verificare',
  'pairing.compare': 'Compară fiecare grup cu amprenta afișată pe dispozitivul nou.',
  'pairing.doNotApprove': 'Nu aproba dacă nu se potrivesc.',
  'pairing.mismatchNote': 'Poate însemna că cheia de asociere a fost schimbată și că cheia portofelului ar putea fi trimisă către dispozitivul greșit.',
  'pairing.confirm': 'Am comparat ambele amprente și se potrivesc exact.',
  'pairing.approve': 'Aprobă dispozitivul',
  'pairing.approving': 'Se aprobă…',
  'pairing.approved': '{device} a fost aprobat.',
  'pairing.errInvalid': 'Această cerere de aprobare conține o cheie de asociere nevalidă. Respinge-o și pornește o cerere nouă.',
  'pairing.errChanged': 'Cheia de asociere s-a schimbat în timpul verificării. Anulează această cerere.',
  'pairing.errApprove': 'Acel dispozitiv nu a putut fi aprobat.',

  'wallet.localOnly': 'Portofel doar local',
  'wallet.lastUsedRecently': 'Folosit recent',
  'wallet.notConnected': 'Nelegat de un cont',
  'wallet.availableOnDevice': 'Portofel disponibil pe acest dispozitiv',
  'wallet.onlyThisDevice': 'Doar pe acest dispozitiv — sincronizarea este oprită',

  'fingerprint.confirmBackup': 'Activezi deblocarea cu amprenta?\n\nDe acum, deschiderea acestui portofel pe acest dispozitiv va cere atât amprenta, cât și PIN-ul. Dacă amprenta nu mai funcționează cândva, poți reintra cu autentificarea de rezervă sau printr-un contact de încredere.',
  'fingerprint.confirmNoBackup': 'Activezi deblocarea cu amprenta?\n\nDe acum, deschiderea acestui portofel pe acest dispozitiv va cere atât amprenta, cât și PIN-ul. Acest portofel nu are încă o copie de siguranță, așa că dacă amprenta nu mai funcționează, nu va mai putea fi deschis. Îți recomandăm insistent să activezi mai întâi sincronizarea.',

  'gate.cloudNotConfigured': 'Cloudul nu este încă configurat. Poți crea acum un portofel local și îl poți lega mai târziu din Setări.',

  'create.title': 'Creează PIN-ul aplicației',
  'create.intro': 'PIN-ul deblochează acest dispozitiv. Parola contului va fi separată când activezi sincronizarea.',
  'create.walletName': 'Numele portofelului',
  'create.walletNameHint': 'Se afișează în acest browser înainte de introducerea PIN-ului.',
  'create.walletNamePlaceholder': 'Alex, Sam, Seiful familiei…',
  'create.deviceName': 'Numele dispozitivului',
  'create.appPin': 'PIN-ul aplicației',
  'create.repeatPin': 'Repetă PIN-ul',
  'create.creating': 'Se creează…',
  'create.createWallet': 'Creează portofelul',
  'create.errPin': 'Folosește un PIN de 6 până la 12 cifre.',
  'create.errMismatch': 'Cele două PIN-uri nu coincid.',
  'create.errFailed': 'Acest portofel nu a putut fi creat.',
  'create.errHello': 'Deblocarea cu amprenta nu a putut fi activată.',
  'create.fingerprintTitle': 'Adaugi amprenta sau chipul?',
  'create.fingerprintCopy': 'O a doua încuietoare, ca o copie furată a portofelului tău să nu poată fi spartă. Vei introduce în continuare PIN-ul.',
  'create.turnOn': 'Activează',
  'create.notNow': 'Nu acum',

  'unlock.title': 'Deblochează Safe Wallet',
  'unlock.unlock': 'Deblochează',
  'unlock.opening': 'Se deschide…',
  'unlock.withFingerprint': 'Deblochează cu amprenta',
  'unlock.wait': 'Așteaptă {seconds}s',
  'unlock.tooManyAttempts': 'Prea multe încercări. Încearcă din nou peste {seconds}s.',
  'unlock.tooMany': 'Prea multe PIN-uri greșite',
  'unlock.tooManyBackup': 'Ia-ți un moment. Poți continua să încerci mai jos sau îți poți recupera accesul cu autentificarea de rezervă ori printr-un contact de încredere.',
  'unlock.tooManyLocal': 'Ia-ți un moment și încearcă din nou cu atenție. Acest portofel există doar pe acest dispozitiv, deci nu există o copie de rezervă.',
  'unlock.forgotPin': 'Ai uitat PIN-ul Safe Wallet?',
  'unlock.errFailed': 'Acest portofel nu a putut fi deschis.',

  'chooser.chooseWallet': 'Alege un portofel',
  'chooser.eachHasPin': 'Fiecare portofel salvat are propriul PIN în acest browser.',
  'chooser.current': 'Curent',
  'chooser.addAnother': 'Adaugă alt cont',

  'existing.title': 'Portofel existent',
  'existing.heading': 'Deschide portofelul meu',
  'existing.intro': 'Folosește parola contului și PIN-ul Safe Wallet pentru a deschide acest portofel pe acest dispozitiv.',
  'existing.openWallet': 'Deschide portofelul',
  'existing.forgotPin': 'Ai uitat PIN-ul Safe Wallet?',
  'existing.advanced': 'Avansat: aprobă de pe alt dispozitiv',
  'existing.advancedNote': 'Folosește această opțiune doar pentru portofelele beta mai vechi, care nu au fost încă actualizate pentru conectarea cu parolă și PIN.',
  'existing.requesting': 'Se solicită…',
  'existing.requestApproval': 'Solicită aprobarea dispozitivului',
  'existing.approvalTitle': 'Aprobarea dispozitivului',
  'existing.unavailable': 'Indisponibil',
  'existing.calculating': 'Se calculează…',
  'existing.mismatchNote': 'O nepotrivire înseamnă că cheia de asociere ar fi putut fi modificată în tranzit. Anulează cererea și nu o aproba.',
  'existing.cancelRequest': 'Anulează cererea',
  'existing.approved': 'Dispozitiv aprobat',
  'existing.setPin': 'Setează un PIN',
  'existing.setPinNote': 'Acest PIN protejează cheia portofelului aprobată pe acest dispozitiv. Poți folosi același PIN Safe Wallet ca pe celelalte dispozitive personale.',
  'existing.finishing': 'Se finalizează…',
  'existing.errPin': 'Folosește un PIN Safe Wallet de 6 până la 12 cifre.',
  'existing.errNoWallet': 'Acest cont nu are încă un Safe Wallet. Creează în schimb un portofel nou.',
  'existing.errUpgrade': 'Este necesară o actualizare unică. Deschide acest portofel o dată pe un dispozitiv unde funcționează deja, activează acolo sincronizarea, apoi încearcă din nou.',
  'existing.errRequest': 'Aprobarea dispozitivului nu a putut fi solicitată.',
  'existing.errCancel': 'Cererea de aprobare nu a putut fi anulată; va expira automat.',
  'existing.errFinish': 'Aprobarea dispozitivului nu a putut fi finalizată.',
  'existing.errPairingInvalid': 'Cheia de asociere locală nu este validă. Anulează și pornește o cerere nouă.',
  'existing.errCancelled': 'Acea cerere de aprobare a fost anulată. Pornește o cerere nouă.',
  'existing.errExpired': 'Acea cerere de aprobare a expirat. Pornește o cerere nouă.',

  'status.onDeviceOnly': 'Doar pe acest dispozitiv',
  'status.syncing': 'Se sincronizează…',
  'status.synced': 'Sincronizat',
  'status.offline': 'Offline',
  'status.saving': 'Se salvează…',
  'status.savingLocal': 'Se salvează pe acest dispozitiv…',
  'status.openingDatabase': 'Se deschide baza de date locală…',
  'status.couldNotStart': 'Pornirea nu a reușit',
  'status.errInit': 'Safe Wallet nu a putut fi pornit.',
  'status.errDatabase': 'Baza de date locală nu este pregătită.',
  'menu.closeMenu': 'Închide meniul',
  'action.showAll': 'Arată tot',

  'conflict.collection': 'Colecție',
  'conflict.deletedVersion': 'O versiune ștearsă intră în conflict cu altă modificare',
  'conflict.multipleChanges': 'Mai multe modificări offline',
  'conflict.title': 'Conflict',
  'conflict.chooseVersion': 'Alege versiunea pe care o păstrezi',
  'conflict.note': 'Ambele versiuni criptate sunt păstrate până când alegi. O versiune ștearsă poate fi aleasă intenționat.',
  'conflict.loading': 'Se încarcă versiunile…',
  'conflict.deleted': 'Versiune ștearsă',
  'conflict.resolving': 'Se rezolvă…',
  'conflict.keepDeleted': 'Păstrează ștearsă',
  'conflict.useThis': 'Folosește această versiune',
  'conflict.errOpen': 'Versiunile în conflict nu au putut fi deschise.',
  'conflict.errResolve': 'Acest conflict nu a putut fi rezolvat.',
  'conflict.screenNote': 'Modificările făcute offline pe mai multe dispozitive rămân criptate și sunt păstrate până când alegi ce versiune păstrezi.',
  'conflict.none': 'Niciun conflict.',

  'collections.newName': 'Numele noii colecții',
  'collections.note': 'Colecțiile sunt dosare private. Un element poate face parte din mai multe colecții.',
  'collections.confirmDelete': 'Ștergi colecția „{name}”? Elementele rămân în Safe Wallet.',

  'item.confirmDelete': 'Ștergi „{title}”? Poate fi restaurat din istoricul copiei de siguranță pentru o perioadă limitată.',
  'reminder.confirmDone': 'Marchezi acest memento ca finalizat?\n\nData mementoului rămâne pe element.',
  'reset.confirmOther': 'Elimini „{name}” din acest browser? Copia criptată din cont nu este ștearsă, iar celelalte portofele din acest browser rămân neatinse. Vei avea nevoie de contul de rezervă și de PIN ca să îl adaugi din nou aici.',
  'reset.confirmLast': 'Elimini acest portofel local din acest browser? Datele criptate deja sincronizate nu sunt șterse din cont. Modificările care așteaptă să fie încărcate și aprobarea acestui browser vor fi șterse.',

  'merge.confirmAdd': 'Acest cont are deja un portofel. Adaugi cele {items} ale tale, inclusiv fotografiile și fișierele, și treci la acel portofel?\n\nPortofelul curent rămâne în acest browser până când îl elimini.',
  'merge.notice': 'S-au adăugat {items} în acest portofel, împreună cu fotografiile și fișierele lor. Vechiul tău portofel „{name}” este încă în acest browser. După ce copia lui de siguranță se încarcă, îl poți elimina mai jos.',
  'merge.removeOld': 'Elimină portofelul vechi',
  'merge.backingUp': 'Se face copia de siguranță…',
  'merge.dismiss': 'Închide',
  'merge.confirmRemoveOld': 'Elimini vechiul portofel „{name}” din acest browser?\n\nElementele lui sunt deja copiate în acest portofel și salvate în contul tău. Astfel se șterge doar vechea copie locală din acest browser.',
  'merge.errMismatch': 'Portofelul care s-a deschis nu corespunde contului ales pentru copiere. Nu s-a eliminat nimic din portofelul original.',
  'merge.errOpenLocal': 'Deschide portofelul local înainte de a-i adăuga elementele în alt portofel.',
  'merge.errNoWallet': 'Acest cont nu are un portofel în care să adaugi elemente.',
  'merge.errKeyPackage': 'Deschide o dată portofelul contului pe dispozitivul unde funcționează deja, apoi încearcă din nou.',
  'merge.errPin': 'Acel PIN nu deschide portofelul aflat deja în acest cont. Introdu PIN-ul acelui portofel.',

  'pin.errNoSync': 'Sincronizarea nu este configurată, așa că PIN-ul nu poate fi actualizat pentru dispozitive noi.',
  'pin.errNoEmail': 'Pentru acest portofel nu există un e-mail de cont pe acest dispozitiv.',
  'pin.errOffline': 'Se pare că ești offline. Reconectează-te pentru a schimba PIN-ul folosit la conectarea pe dispozitive noi.',
  'pin.errWrongPassword': 'Acea parolă de cont nu este corectă.',
  'pin.errDeviceUnavailable': 'Acest dispozitiv nu este disponibil.',
  'pin.changedBoth': 'PIN schimbat pe acest dispozitiv și pentru conectarea pe dispozitive noi.',
  'pin.changedLocal': 'PIN-ul aplicației a fost schimbat. Folosește noul PIN data viitoare când acest dispozitiv se blochează.',

  'recover.accountTitle': 'Cont Safe Wallet',
  'recover.passwordChanged': 'Parolă schimbată',
  'recover.passwordChangedNote': 'Conectează-te din nou cu noua parolă a contului. PIN-ul aplicației și portofelul tău criptat nu au fost modificate.',
  'recover.continue': 'Continuă',
  'recover.choosePassword': 'Alege o parolă nouă',
  'recover.choosePasswordNote': 'Aceasta schimbă doar parola contului de sincronizare. PIN-ul aplicației rămâne neschimbat, iar singură această parolă nu îți deschide portofelul criptat pe un dispozitiv nou.',
  'recover.checkingLink': 'Se verifică linkul de recuperare…',
  'recover.newPassword': 'Parola nouă a contului',
  'recover.repeatPassword': 'Repetă parola nouă',
  'recover.updating': 'Se actualizează…',
  'recover.updatePassword': 'Actualizează parola',
  'recover.errShort': 'Folosește cel puțin 8 caractere.',
  'recover.errMismatch': 'Cele două parole nu coincid.',
  'recover.errUpdate': 'Parola contului nu a putut fi actualizată.',

  'recover.walletTitle': 'Recuperarea portofelului',
  'recover.freshVerification': 'Recuperarea unui portofel cere întotdeauna o verificare nouă a contului tău. Safe Wallet nu cere niciodată codul tău unui contact de încredere.',
  'recover.useOnlyWhen': 'Folosește această opțiune doar dacă niciun dispozitiv al tău nu îți poate reseta PIN-ul. Ai nevoie de o verificare nouă prin e-mail și de aprobarea unui contact Safe Wallet de încredere.',
  'recover.accountEmail': 'E-mailul contului',
  'recover.emailCode': 'Codul de verificare primit pe e-mail',
  'recover.sendAnother': 'Trimite alt cod',
  'recover.authenticator': 'Aplicație de autentificare',
  'recover.authenticatorCode': 'Codul din aplicația de autentificare',
  'recover.verifyStart': 'Verifică e-mailul și începe',
  'recover.verifyContinue': 'Verifică e-mailul și continuă',
  'recover.deviceFingerprint': 'Amprenta dispozitivului care recuperează',
  'recover.readFingerprint': 'Citește-i această amprentă contactului tău de încredere într-o convorbire în direct. El trebuie să te sune la datele de contact pe care le avea deja — niciodată la un număr trimis special pentru asta.',
  'recover.status': 'Stare:',
  'recover.waitingEnds': 'Perioada de așteptare se încheie:',
  'recover.expires': 'Expiră:',
  'recover.cancel': 'Anulează recuperarea',
  'recover.setNewPin': 'Setează un PIN nou',
  'recover.keyRebuilt': 'Cheia portofelului tău a fost reconstruită doar în acest browser. Protecția de recuperare s-a consumat și trebuie configurată din nou.',
  'recover.deviceName': 'Numele dispozitivului',
  'recover.newPin': 'PIN nou pentru aplicație',
  'recover.repeatPin': 'Repetă PIN-ul',

  'invite.securityConfirmation': 'Confirmare de securitate',
  'invite.title': 'Invitație de recuperare',
  'invite.helpSomeone': 'Ajută pe cineva în care ai încredere',
  'invite.invitedBy': 'Invitat de',
  'invite.askedYou': 'Această persoană ți-a cerut să îi fii contact de încredere pentru recuperare.',

  'invite.cannotSee': 'Nu îi poți vedea portofelul.',
  'invite.cannotSeeNote': 'Ce a salvat acolo rămâne criptat și privat.',
  'invite.cannotRecover': 'Nu îl poți recupera singur.',
  'invite.cannotRecoverNote': 'Ajuți abia după ce proprietarul pornește el însuși recuperarea.',
  'invite.nothingToRemember': 'Nu ai nimic de ținut minte.',
  'invite.nothingToRememberNote': 'Safe Wallet pregătește totul în siguranță imediat ce accepți.',
  'invite.enterPin': 'Introdu PIN-ul tău',
  'invite.confirming': 'Se confirmă…',
  'invite.decline': 'Refuză',
  'invite.accept': 'Acceptă invitația',
  'invite.confirmWithPin': 'Confirmă cu PIN-ul tău',
  'invite.acceptTitle': 'Acceptă invitația de recuperare',
  'invite.confirmBecome': 'Confirmă că vrei să devii contact de recuperare pentru:',
  'invite.declineTitle': 'Refuză invitația',
  'invite.declineQuestion': 'Nu devii contact de recuperare?',
  'invite.invitationFrom': 'Invitația de la',
  'invite.keep': 'Păstrează invitația',
  'invite.accepted': 'Invitație acceptată',
  'invite.nowContact': 'Acum ești contact de recuperare',
  'invite.nothingUnless': 'Nu ai nimic de făcut, decât dacă',
  'invite.inboxTitle': 'Invitații de recuperare',
  'invite.review': 'Verifică invitația',
  'invite.errConfirm': 'Nu s-a putut confirma.',
  'invite.errAccept': 'Această invitație nu a putut fi acceptată.',
  'invite.errDecline': 'Această invitație nu a putut fi refuzată.',

  'protect.preparing': 'Se pregătește protecția de recuperare…',
  'protect.addPerson': 'Adaugă o persoană de încredere',
  'protect.addPersonNote': 'O persoană de încredere te poate ajuta să reintri în portofel. Nu îți poate vedea portofelul și nu îl poate recupera fără tine.',
  'protect.addSoYouCan': 'Adaugă o persoană de încredere ca să poți reintra dacă îți pierzi PIN-ul sau dispozitivul.',
  'protect.mustHaveAccount': 'Trebuie să aibă deja un cont Safe Wallet.',
  'protect.useTheirEmail': 'Folosește adresa de e-mail legată de Safe Wallet-ul ei.',
  'protect.emailLabel': 'E-mailul Safe Wallet al persoanei de încredere',
  'protect.emailPlaceholder': 'nume@exemplu.ro',
  'protect.send': 'Trimite invitația',
  'protect.yourPeople': 'Persoanele tale de încredere',
  'protect.onlyYouSee': 'Doar tu vezi această listă.',
  'protect.waiting': 'Se așteaptă acceptul',
  'protect.pending': 'În așteptare',
  'protect.canHelp': 'Poate ajuta când ceri recuperarea',
  'protect.active': 'Activă',
  'protect.protectionActive': 'Protecția de recuperare este activă',
  'protect.becomesActive': 'Protecția de recuperare începe să funcționeze când o persoană invitată acceptă.',
  'protect.errLoad': 'Protecția de recuperare nu a putut fi încărcată.',
  'protect.errSelf': 'Alege alt utilizator Safe Wallet.',
  'protect.errNoAccount': 'Nu s-a găsit niciun cont Safe Wallet pentru acest e-mail. Roagă persoana să își creeze și să își confirme mai întâi contul.',
  'protect.errNotReady': 'Acest cont Safe Wallet nu este încă pregătit pentru invitații de recuperare. Roagă persoana să deschidă și să deblocheze o dată Safe Wallet-ul actualizat, apoi încearcă din nou.',
  'protect.errCheck': 'Acest cont Safe Wallet nu a putut fi verificat.',
  'protect.errSend': 'Această invitație nu a putut fi trimisă.',
  'invite.willBeRemoved': 'va fi eliminată. Te poate invita din nou mai târziu.',
  'invite.asksForHelp': 'cere ajutor ca să reintre în portofelul său.',
  'protect.notSetUp': 'Neconfigurată',
  'protect.checking': 'Se verifică…',
  'reminder.done': 'Gata',
  'reminder.doneOn': 'Gata pe {date}',
  'invite.enterWalletPin': 'Introdu PIN-ul Safe Wallet',
  'invite.confirmInviteNote': 'Confirmă că vrei să inviți această persoană drept contact de recuperare.',
  'invite.confirmInvite': 'Confirmă invitația',
  'recover.startTitle': 'Începe recuperarea',
  'recover.continueTitle': 'Continuă recuperarea',
  'invite.invitedYouTo': 'te-a invitat să îi fii contact de încredere pentru recuperare.',
  'approve.inboxTitle': 'Cineva are nevoie de ajutorul tău',
  'approve.isRecovering': 'încearcă să reintre în portofelul său.',
  'approve.review': 'Verifică cererea',
  'approve.title': 'Aprobi reintrarea?',
  'approve.fingerprintLabel': 'Codul afișat pe dispozitivul său nou',
  'approve.callFirst': 'Sună-l mai întâi — la un număr pe care îl aveai deja, niciodată la unul primit acum. Roagă-l să îți citească codul de pe ecranul lui și verifică dacă se potrivește exact cu acesta.',
  'approve.onlyIfSure': 'Aprobă doar dacă codul se potrivește și ești sigur că este chiar el. Dacă nu, anunță-l imediat ca să poată anula cererea.',
  'approve.approve': 'Codurile se potrivesc — aprobă',
  'approve.approving': 'Se aprobă…',
  'approve.notNow': 'Nu acum',
  'approve.done': 'Aprobat. Acum poate reintra.',
  'approve.errApprove': 'Această cerere nu a putut fi aprobată.',
  'approve.waitUntil': 'Poate continua de la {time}.',
};

// Romanian uses three forms: one, few (numbers ending 01–19 above 20, and 2–19) and other.
export const plurals: Plurals = {
  items: { one: '{count} element', few: '{count} elemente', other: '{count} de elemente' },
  minutes: { one: '{count} minut', few: '{count} minute', other: '{count} de minute' },
  queued: { one: '{count} modificare în așteptare', few: '{count} modificări în așteptare', other: '{count} de modificări în așteptare' },
  helpers: { one: '{count} persoană de încredere gata să ajute.', few: '{count} persoane de încredere gata să ajute.', other: '{count} de persoane de încredere gata să ajute.' },
};
